import { useContext } from "react";
import { HighlightContext } from "../context/HighlightContext";

export function useHighlight() {
  return useContext(HighlightContext);
}
